import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@4.3.0_webpack@4.47.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down_btn",
  "use": "icon-down_btn-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-down_btn\">\r\n<style type=\"text/css\">\r\n\t#icon-down_btn .st0{}\r\n</style>\r\n<path class=\"st0\" d=\"M4.6,9.6l2.3,2.6c0.3,0.3,0.7,0.5,1.1,0.5c0.4,0,0.9-0.2,1.1-0.5L15.5,5c0.6-0.7,0.4-1.3-0.5-1.3H1\r\n\tC0.1,3.8-0.1,4.4,0.5,5L4.6,9.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol